export default __webpack_public_path__ + "static/media/securing-perimeters.cc7d72a5.jpg";